import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Info, X } from 'lucide-react';

const STORAGE_KEY = 'paygatex-wallets-info-banner-hidden';

const readHidden = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export function WalletsInfoBanner() {
  const { t } = useTranslation('cabinet');
  const [isHidden, setIsHidden] = useState(readHidden);

  if (isHidden) return null;

  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-start gap-2.5 rounded-lg border border-border bg-accent/40 p-3 sm:gap-3 sm:p-4">
      <Info className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
      <div className="min-w-0 text-sm">
        <p className="font-medium text-foreground">{t('wallets.infoBanner.title')}</p>
        <p className="mt-0.5 text-muted-foreground">{t('wallets.infoBanner.body')}</p>
      </div>
      <button
        type="button"
        onClick={() => {
          try {
            localStorage.setItem(STORAGE_KEY, '1');
          } catch {
            /* ignore */
          }
          setIsHidden(true);
        }}
        aria-label={t('common.close', { ns: 'common' })}
        className="shrink-0 rounded-sm p-1 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
